export default function preparationItemUniqueNameDirective(
  $q,
  amSharedModelService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const preparationItemCategoryId = attributes.preparationItemCategoryId || -1;
    const preparationItemId = attributes.preparationItemId || -1;

    ngModel.$asyncValidators.amPreparationItemUniqueName = modelValue => amSharedModelService
      .checkPreparationItemNameExists(preparationItemCategoryId, preparationItemId, modelValue)
      .then((nameExists) => {
        if (!nameExists) {
          return $q.resolve();
        }
        return $q.reject();
      })
      .catch(() => $q.reject());
  }
}

export const name = 'amPreparationItemUniqueName';

preparationItemUniqueNameDirective.$inject = [
  '$q',
  'amSharedModelService'
];
